import { connectHook } from '../../connect-hook';
import { Switch } from './switch';
import { useSwitch } from './switch-hook';

export default connectHook(Switch, useSwitch);
